import React from 'react';
import { connect } from 'react-redux';
import QueryString from 'query-string';
import ReactTable from 'react-table';
import i18next from 'i18next';

import { Message } from '../Message';
import { PageTitle } from '../PageTitle';
import { RowButton } from '../RowButton';
import { ActionsService } from '../../services';
import { AccessHelper, BaseTable } from '../../helpers';

@connect(state => {
  return {
    me: state.user.me
  }
})
class Actions extends React.Component {
  constructor(props) {
    super(props);

    const passedState = props.history.location ? props.history.location.state : null;

    this.DEFAULT_SORTED = [];

    this.state = {
      localErrorHandler: this.handleLocalError.bind(this),
      localErrorMessage: null,
      hasError: false,
      data: [],
      pageCount: null,
      forcePage: null,
      totalElements: null,
      loading: true,
      parsedOptions: QueryString.parse(this.props.location.search),
      currentHistoryCount: passedState && passedState.currentHistoryCount ? passedState.currentHistoryCount : 0,
      viewAllowed: AccessHelper.userHasAccess(this.props.me.availableRoutes, '/config/actions/view/:actionId'),
      editAllowed: AccessHelper.userHasAccess(this.props.me.availableRoutes, '/config/actions/edit/:actionId'),
    };
  }

  messageDismissCallback() {
    this.setState({ localErrorMessage: null });
  }

  renderMessages() {
    if (this.state.localErrorMessage) {
      return (
        <Message errorMessage={this.state.localErrorMessage} messageDismissCallback={this.messageDismissCallback.bind(this)} />
      );
    }

    if (this.props.location.state) {
      return (
        <Message messages={this.props.location} />
      );
    }
    return null;
  }

  handleLocalError(localErrorMessage) {
    this.setState({ localErrorMessage: localErrorMessage });
  }

  fetchData(tableData) {
    if (this.updateRequestURL(tableData)) {
      return;
    }

    this.setState({
      loading: true
    });

    let options = BaseTable.buildFetchDataOptions(this.state.parsedOptions, this.DEFAULT_SORTED);

    ActionsService.getAll(options, true).then(response => {
      const pageCount = Math.ceil(response.page.totalElements / this.refs.actionsTable.state.pageSize);

      let forcePage = null;
      if (this.refs.actionsTable && this.refs.actionsTable.state
        && this.refs.actionsTable.state.page >= pageCount) {
        forcePage = pageCount - 1;
      }
      this.setState({
        data: response.actions,
        pageCount: pageCount,
        forcePage: forcePage,
        totalElements: response.page.totalElements,
        loading: false
      });
    }).catch(error => {
      console.error(error);
      this.setState({ hasError: true });
      this.state.localErrorHandler(error.message);
    });
  }

  updateRequestURL(tableData) {
    let options = BaseTable.buildURLOptions(tableData, this.DEFAULT_SORTED)

    let params = options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}`)).join('&');

    const currentSearch = this.props.location.search ? this.props.location.search : '?';

    if (`?${params}` !== currentSearch) {
      if (this.state.currentHistoryCount > 100) {
        console.error('Exceeded the history count stack of 100.');
        return false;
      }
      this.props.history.push({
        search: `?${params}`,
        state: {
          currentHistoryCount: this.state.currentHistoryCount + 1
        }
      });
      return true;
    } else {
      return false;
    }
  }

  render() {
    let dynamicOptions = BaseTable.buildDynamicOptions(this.state.parsedOptions, this.state.forcePage, this.DEFAULT_SORTED);
    
    return (
        <div className="animated fadeIn">
          <div className="row">
            <PageTitle title={i18next.t('pages.actions.header')}
                       addLinkWithParams={{
                         link: {
                           pathname: "/config/actions/add",
                           state: {
                             backLinkSearch: this.props.location.search
                           }
                         }
                       }} />
          </div>

          {this.renderMessages()}

          <div className="op-content-box">
            <div className="row">
              <div className="col-sm-12">
                <div>
                  <div className="card-block">
                    <div className="react-table-custom">
                      <ReactTable
                        className="-striped -highlight"
                        ref="actionsTable"
                        manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                        data={this.state.data}
                        pages={this.state.pageCount} // Display the total number of pages
                        loading={this.state.loading} // Display the loading overlay when we need it
                        totalElements={this.state.totalElements}
                        onFetchData={this.fetchData.bind(this)} // Request new data when things change
                        showPaginationTop
                        columns={[
                                    {
                                      Header: i18next.t('table-headers.name'),
                                      accessor: "name",
                                      sortable: true,
                                      minResizeWidth: 50
                                    },
                                    {
                                      Cell: cell => <RowButton
                                                      allowView={this.state.viewAllowed}
                                                      allowEdit={this.state.editAllowed}
                                                      viewPath={{
                                                        pathname: `/config/actions/view/${cell.original.id}`,
                                                        state: { backLinkSearch: this.props.location.search }
                                                      }}
                                                      editPath={{
                                                        pathname: `/config/actions/edit/${cell.original.id}`,
                                                        state: { backLinkSearch: this.props.location.search }
                                                      }} />,
                                      sortable: false,
                                      minResizeWidth: 50,
                                      width: 150
                                    }
                                  ]}
                        {...dynamicOptions}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

export default Actions;
